module.exports = __webpack_public_path__ + "img/courseImg1.387d1ff1.png";